import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHealthMetrics = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_10052_25432",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_10052_25432)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M6.24996 17.8525V13.75H2.14746V6.24996H6.24996V2.14746H13.75V6.24996H17.8525V13.75H13.75V17.8525H6.24996ZM3.39746 9.37496H7.49996C7.60677 9.37496 7.70531 9.40031 7.79559 9.451C7.88586 9.50184 7.95774 9.56948 8.01121 9.65392L8.98079 11.0977L10.242 7.31413C10.2869 7.18482 10.3622 7.07934 10.4679 6.99767C10.5737 6.91586 10.695 6.87496 10.8316 6.87496C10.9369 6.87496 11.0369 6.90079 11.1316 6.95246C11.2262 7.00413 11.2998 7.07128 11.3525 7.15392L12.8252 9.37496H16.6025V7.49996H12.5V3.39746H7.49996V7.49996H3.39746V9.37496ZM7.49996 16.6025H12.5V12.5H16.6025V10.625H12.5C12.3957 10.625 12.2966 10.5984 12.2027 10.5452C12.1088 10.4921 12.0305 10.4231 11.9679 10.3381L11.0191 8.90225L9.75788 12.6858C9.71302 12.8151 9.63427 12.9206 9.52163 13.0023C9.40885 13.0841 9.28336 13.125 9.14517 13.125C9.03878 13.125 8.94045 13.0996 8.85017 13.0489C8.75989 12.9981 8.68802 12.9304 8.63454 12.846L7.15392 10.625H3.39746V12.5H7.49996V16.6025Z",
			fill: "#064C68"
		})
	})]
});
export default SvgHealthMetrics;
